var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallSplit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.669273 5.35026L5.73594 5.35026L9.06927 2.01693L7.33594 2.01693L7.33594 0.683594L11.3359 0.683594L11.3359 4.68359L10.0026 4.68359L10.0026 2.95026L6.26927 6.68359L0.669273 6.68359L0.669273 5.35026ZM6.93594 7.91693L7.90261 6.95026L10.0026 9.08359L10.0026 7.35026L11.3359 7.35026L11.3359 11.3503L7.33594 11.3503L7.33594 10.0169L9.06927 10.0169L6.93594 7.91693Z",
    fill: "#8B8D97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallSplit);
export default __webpack_public_path__ + "static/media/call_split.8da436f3dd9dc110b864d35bb7d1fb76.svg";
export { ForwardRef as ReactComponent };